export default __webpack_public_path__ + "static/media/twitter.ca88c85b.svg";